import { phone } from 'fitify-ui-landing/src/theme/breakpoints'
import styled, { css } from 'styled-components'

export const WIDTH = `984px`
export const PADDING = `40px`
export const PADDING_PHONE = `24px`

export const StyledContainer = styled.div`
  width: 100%;
  max-width: calc(${WIDTH} + ${PADDING} * 2);
  padding: 0 ${PADDING};
  margin: 0 auto;

  ${phone(css`
    padding: 0 ${PADDING_PHONE};
  `)};
`
